import React, { useState } from 'react';
import { Button, Icon, Tooltip } from '@pwc/pwc-deals-ui';
import { useDispatch } from 'react-redux';
import { toggleRightPanel2 } from '../../../../redux/reportFormat/reportFormatSlice';
import ReportLayoutButton from '../../../ReportLayoutIcon/ReportLayoutButton';

const SectionControls = ({
  controlsActive,
  section,
  lastSection,
  handleMoveSection,
  handleRemoveSection,
  moreSectionsAllowed = false,
}) => {
  const dispatch = useDispatch();

  const handleCollapse = (e) => {
    e.preventDefault();
    dispatch(toggleRightPanel2());
  };

  const [iconProperties, setIconProperties] = useState({
    moveDown: 'outline',
    moveUp: 'outline',
    remove: 'outline',
  });

  const handleMoveDown = (e) => {
    e.preventDefault();
    handleMoveSection('down');
  };

  const handleMoveUp = (e) => {
    e.preventDefault();
    handleMoveSection('up');
  };

  const handleRemove = (e) => {
    e.preventDefault();
    handleRemoveSection();
  };

  return (
    <div className="section__controls">
      <div className="report_layout-icon">
        <ReportLayoutButton
          onClick={handleCollapse}
          layoutType={section.layoutType}
        />
      </div>
      {moreSectionsAllowed && (
        <Tooltip direction="top" tip="Move down">
          <Button
            className="mr-2 control-item move-down button-no-underline"
            disabled={!controlsActive || lastSection}
            onClick={handleMoveDown}
            onMouseEnter={() =>
              setIconProperties({
                ...iconProperties,
                moveDown: 'fill',
              })
            }
            onMouseLeave={() =>
              setIconProperties({
                ...iconProperties,
                moveDown: 'outline',
              })
            }
            data-testid="move-section-down"
            tabIndex={0}
          >
            <Icon
              name="move-down"
              className={`${iconProperties.moveDown} icon-${
                controlsActive && !lastSection ? 'orange-theme' : 'grey-medium'
              }`}
              width={24}
              height={24}
            />
          </Button>
        </Tooltip>
      )}
      {moreSectionsAllowed && (
        <Tooltip direction="top" tip="Move up">
          <Button
            className="mx-2 control-item button-no-underline"
            disabled={!controlsActive || section.order === 1}
            onClick={handleMoveUp}
            onMouseEnter={() =>
              setIconProperties({
                ...iconProperties,
                moveUp: 'fill',
              })
            }
            onMouseLeave={() =>
              setIconProperties({
                ...iconProperties,
                moveUp: 'outline',
              })
            }
            data-testid="move-section-up"
            tabIndex={0}
          >
            <Icon
              name="move-up"
              className={`${iconProperties.moveUp} icon-${
                controlsActive && section.order !== 1
                  ? 'orange-theme'
                  : 'grey-medium'
              }`}
              width={24}
              height={24}
            />
          </Button>
        </Tooltip>
      )}
      {moreSectionsAllowed && (
        <Tooltip direction="top" tip="Remove section">
          <Button
            className="ml-2 control-item button-no-underline"
            onClick={handleRemove}
            disabled={!controlsActive}
            onMouseEnter={() =>
              setIconProperties({
                ...iconProperties,
                remove: 'fill',
              })
            }
            onMouseLeave={() =>
              setIconProperties({
                ...iconProperties,
                remove: 'outline',
              })
            }
            data-testid="remove-section"
            tabIndex={0}
          >
            <Icon
              name="bin"
              className={`${iconProperties.remove} icon-${
                controlsActive ? 'orange-theme' : 'grey-medium'
              }`}
              width={24}
              height={24}
            />
          </Button>
        </Tooltip>
      )}
    </div>
  );
};

export default SectionControls;
